import {styled} from 'styled-components';

export const FullScreenMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.66rem;
  text-align: center;
  color: #555;
  padding: 1rem;
  box-sizing: border-box;
`;
